import { createComponent } from "@lit/react";
import * as React from "react";
import { importAndRegisterComponent } from "../../components/register.js";

export const registerReactComponent = (prefix, beaconClass) => {
  importAndRegisterComponent(prefix, beaconClass);
  const scopedTagName = prefix + "-" + beaconClass.tagName;
  return createComponent({
    tagName: scopedTagName,
    elementClass: beaconClass,
    react: React,
    events: {},
  });
};
